/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This component was generated against an existing platform component.
 * If you are seeing lint errors in this file, it means that this file's dependencies have been modified and the component will need to be regenerated.
 *
 * Please view https://hello.atlassian.net/wiki/spaces/ECO/pages/3358130330/How+to+Regenerate+UI+Kit+Components for more information on how to proceed.
 *
 * For further questions, please ping the #help-forge-ui channel.
 *
 * @codegen <<SignedSource::aadc8f093ff3f3e1730f42ea9a70a445>>
 * @codegenId #tile
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen tile
 * @codegenParams { "props": { "backgroundColor": true, "label": true, "size": true, "children": true, "hasBorder": true, "isInset": true, "testId": true } }
 * @codegenDependency ../../../../../../../design-system/tile/src/types.tsx <<SignedSource::239e1f3506078a0ea513ee58a3b0bff7>>
 * @codegenDependency ../../../../../../../design-system/tile/src/tile.tsx <<SignedSource::cca0ee622daf7895fc5ad727d8ab3ca9>>
 */
/* eslint @repo/internal/codegen/signed-source-integrity: "warn" */
import React from 'react';
import type { RenderFn } from '@atlassian/forge-ui-types';
import PlatformTile from '@atlaskit/tile';

type PlatformTileProps = React.ComponentProps<typeof PlatformTile>;

export type TileProps = Pick<
  PlatformTileProps,
  'backgroundColor' | 'label' | 'size' | 'children' | 'hasBorder' | 'isInset' | 'testId'
>;

/**
 * A tile is a rounded square that takes an asset and represents a noun.
 */
export const Tile = (props: Parameters<RenderFn>[0]): React.JSX.Element => {
  const {
    backgroundColor,
    label,
    size,
    hasBorder,
    isInset,
    testId,
  } = props.forgeDoc.props as TileProps;
  return (
    <PlatformTile
      backgroundColor={backgroundColor}
      label={label}
      size={size}
      children={props.forgeDoc.children.map(c => <React.Fragment key={c.key}>{props.render(c)}</React.Fragment>)}
      hasBorder={hasBorder}
      isInset={isInset}
      testId={testId}
    />
  );
};
/**
 * @codegenEnd
 */
